import React from 'react';
import NorthumbriaWaterLogo from '/img/NW_logo_colour.jpg';

interface NwlLogoProps {
	onClick: () => void;
}

const NwlLogo: React.FC<NwlLogoProps> = ({ onClick }) => {
	return (
		<img
			src={NorthumbriaWaterLogo}
			alt="Northumbrian_Water_logo"
			style={{
				width: '143px',
				position: 'relative',
				bottom: '-5px',
				cursor: 'pointer',
			}}
			onClick={onClick}
		/>
	);
};

export default NwlLogo;